export default "__VITE_ASSET__CoqdB7vM__"